export enum AuthPayloadParam {
  AccessToken = 'access_token',
  IdToken = 'id_token',
  RefreshToken = 'refresh_token',
  ClientId = 'client_id',
}

export enum AuthRedirectParam {
  ResponseType = 'response_type',
  ClientId = 'client_id',
  AuthType = 'auth_type',
  RedirectUri = 'redirect_uri',
}

export enum AuthType {
  Default = 'default',
  Reauthenticate = 'reauthenticate',
}
